import { InspectionStatus as ClaimsInspectionStatus } from '@eigtech/claims-v2-types'
import { InspectionStatus as InspectionsInspectionStatus } from '@eigtech/inspections-types'
import { exhaustive } from 'exhaustive'
import { startCase } from 'lodash-es'

type InspectionStatus = ClaimsInspectionStatus | InspectionsInspectionStatus

const inspectionStatusLabelRecord: Partial<Record<InspectionStatus, string>> = {}

export const getInspectionStatusLabel = (status: InspectionStatus) =>
  inspectionStatusLabelRecord[status] ?? startCase(status)

export const getInspectionStatusColorScheme = (inspectionStatus: InspectionStatus) =>
  exhaustive(inspectionStatus, {
    canceled: () => 'yellow',
    completed: () => 'green',
    readyForReview: () => 'orange',
    requested: () => 'purple',
    scheduled: () => 'blue',
    started: () => 'red',
  })
